import { createContext, useContext, useState, useCallback } from 'react';

// Context for pages that manage campus selection internally.
// When a page sets `pageCampusMode = true`, the topbar campus selector is hidden
// and replaced with a "Campus: Managed in page" indicator.

const PageCampusContext = createContext({
  pageCampusMode: false,
  setPageCampusMode: () => {},
});

export function PageCampusProvider({ children }) {
  const [pageCampusMode, setPageCampusModeState] = useState(false);

  const setPageCampusMode = useCallback((val) => {
    setPageCampusModeState(val);
  }, []);

  return (
    <PageCampusContext.Provider value={{ pageCampusMode, setPageCampusMode }}>
      {children}
    </PageCampusContext.Provider>
  );
}

export function usePageCampus() {
  return useContext(PageCampusContext);
}

export default PageCampusContext;
